<template>
    <CustomizerHeader />
    
    <!-- GLOBALER SMART STEP INDICATOR -->
    <SmartStepIndicator 
        :showExplanation="true"
    />
    
    <div id="content">
        <router-view />
    </div>
    <PopUp id="popup-speech-to-text">
        <img
            src="@/assets/customizer_speech_to_text_help_new-min.png"
            alt="Spreche Deine Geschichte"
        />
    </PopUp>
</template>

<script>
import CustomizerHeader from "@/components/CustomizerHeader";
import PopUp from "@/components/PopUp.vue";
import SmartStepIndicator from "@/components/SmartStepIndicator.vue";
import EventBus from "@/event-bus";

export default {
    name: "App",
    components: {
        CustomizerHeader,
        PopUp,
        SmartStepIndicator,
    },
    data() {
        return {
            globalPageSettings: {
                step1Url: "",
                step2Url: "",
                step3Url: "",
                storageKey: "",
                step1StorageKey: "",
                step2StorageKey: "",
                step3StorageKey: "",
                variant: "",
                product: "",
            },
        };
    },
    provide() {
        return {
            pageSettings: this.globalPageSettings,
        };
    },
    methods: {
        handlePageSettingsUpdated(newPageSettings) {
            Object.assign(this.globalPageSettings, newPageSettings);
        },
    },
    mounted() {
        EventBus.on("pageSettingsUpdated", this.handlePageSettingsUpdated);
    },
    beforeUnmount() {
        EventBus.off("pageSettingsUpdated", this.handlePageSettingsUpdated);
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/customizer.vars.scss" as *;

#content {
    max-width: 744px;
    padding: 80px 0;
    margin: 0 auto;

    @media (max-width: $breakpoint-tablet) {
        padding: 16px 16px 40px;
    }
}

#popup-speech-to-text {
    img {
        display: block;
        width: 100%;
        max-width: 200px;
        margin: 0 auto;
    }
}
</style>
